<template>
  <v-sheet
    v-if="items.length"
    color="transparent"
    class="categories py-lg-16 py-md-14 py-6"
  >
    <v-container>
      <div class="d-flex justify-center pb-8 pb-sm-10 pb-md-16">
        <span
          class="
            text-uppercase text-h4 text-sm-h3 text-md-h2
            font-weight-bold font-italic
            text-center
          "
        >
          As melhores opções de <br />
          pneus para o seu veículo!
        </span>
      </div>
      <div class="relative carrousel-container">
        <VueSlickCarousel
          class="vue-slick-carousel px-3"
          v-bind="settings"
          ref="carousel"
        >
          <template v-for="({ img, title }, i) in items">
            <div class="px-5 px-sm-8" :key="i">
              <div class="d-flex flex-column align-center">
                <img
                  width="100%"
                  class="categories-img"
                  :src="files + img"
                  :alt="title"
                />
                <span
                  class="
                    pt-3 pt-sm-5
                    font-weight-bold font-italic
                    text-h6 text-md-h4
                    primary--text
                    text-uppercase
                  "
                  >{{ title }}</span
                >
              </div>
            </div>
          </template>
        </VueSlickCarousel>
        <div class="d-flex justify-space-between vue-slick-carousel-nav">
          <v-btn class="transparent" icon text @click="showPrev">
            <v-icon color="primary" size="24"> fas fa-chevron-left </v-icon>
          </v-btn>
          <v-btn class="transparent" icon text @click="showNext">
            <v-icon color="primary" size="24"> fas fa-chevron-right </v-icon>
          </v-btn>
        </div>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  data: () => ({
    settings: {
      swipe: true,
      dots: false,
      infinite: true,
      arrows: false,
      autoplay: true,
      slidesToScroll: 1,
      slidesToShow: 6,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1264,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    },
  }),
  computed: {
    items() {
      return this.$rest("categories").list;
    },
  },
  methods: {
    showNext() {
      this.$refs.carousel.next();
    },
    showPrev() {
      this.$refs.carousel.prev();
    },
  },
  components: { VueSlickCarousel },
};
</script>

<style lang="scss" scoped>
.vue-slick-carousel {
  position: relative;
  z-index: 2;
}
.categories {
  .carrousel-container {
    &::after {
      content: "";
      height: 50px;
      background: rgba(255, 255, 255, 0.7);
      filter: blur(9px);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -5%;
      right: -5%;
      border-radius: 50%;
      z-index: 1;
    }
  }
  .vue-slick-carousel-nav {
    position: absolute;
    pointer-events: none;
    left: -25px;
    right: -25px;
    top: 30%;
    z-index: 2;
    button {
      pointer-events: all;
    }
    @media (max-width: 960px) {
      left: -15px;
      right: -15px;
    }
  }
  background: linear-gradient(
    180deg,
    #e6ebe9 68.46%,
    rgba(235, 235, 235, 0) 100%
  );
  &-img {
    height: 137.36px !important;
    object-fit: contain;
    aspect-ratio: 101.07 / 137.36;
    pointer-events: none;
  }
}
</style>
